import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "flex items-start justify-between mb-3 sm:mb-4" }
const _hoisted_2 = { class: "text-lg sm:text-xl lg:text-2xl font-bold text-gray-900 dark:text-white mb-2 sm:mb-3 leading-tight break-words" }
const _hoisted_3 = { class: "block text-base sm:text-lg font-semibold text-gray-600 dark:text-gray-300 mt-0.5" }
const _hoisted_4 = { class: "inline-flex items-center gap-1.5 sm:gap-2 px-3 py-1.5 sm:px-4 sm:py-2 bg-white dark:bg-black rounded-lg border-2 border-gray-200 dark:border-gray-600 shadow-sm max-w-full" }
const _hoisted_5 = { class: "font-mono font-bold text-sm sm:text-base text-gray-900 dark:text-white tracking-wider truncate uppercase" }
const _hoisted_6 = { class: "px-4 sm:px-5 lg:px-6 py-3 sm:py-4 bg-gradient-to-r from-gray-50 to-gray-100 dark:from-gray-900 dark:to-gray-800 border-y border-gray-200 dark:border-gray-700" }
const _hoisted_7 = { class: "flex items-center gap-2 sm:gap-3" }
const _hoisted_8 = { class: "flex-1 min-w-0" }
const _hoisted_9 = { class: "text-base sm:text-lg font-bold text-gray-900 dark:text-white" }
const _hoisted_10 = { class: "text-xs sm:text-sm font-normal text-gray-600 dark:text-gray-400" }
const _hoisted_11 = { class: "px-4 sm:px-5 lg:px-6 py-3 sm:py-4 bg-white dark:bg-black mt-auto" }
const _hoisted_12 = { class: "hidden lg:flex gap-1.5 2xl:gap-1" }
const _hoisted_13 = { class: "lg:hidden space-y-2" }
const _hoisted_14 = { class: "flex gap-2" }

import type { Vehicle } from '@/types/vehicle';
import { useBrand } from '@/composables/brand/useBrand';


export default /*@__PURE__*/_defineComponent({
  __name: 'VehicleCard',
  props: {
    vehicle: {}
  },
  emits: ["view", "edit", "delete"],
  setup(__props: any) {





const { brandColors } = useBrand();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "group bg-white dark:bg-black rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden border-2 border-gray-100 dark:border-gray-700 hover:border-opacity-0 transform hover:-translate-y-2 flex flex-col h-full",
    style: _normalizeStyle({
      borderColor: _unref(brandColors).primary + '60',
      '--brand-color': _unref(brandColors).primary
    })
  }, [
    _createElementVNode("div", {
      class: "relative p-4 sm:p-5 lg:p-6 pb-4",
      style: _normalizeStyle({ background: `linear-gradient(135deg, ${_unref(brandColors).primary}12 0%, ${_unref(brandColors).primary}05 100%)` })
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "w-12 h-12 sm:w-14 sm:h-14 rounded-2xl flex items-center justify-center shadow-md group-hover:scale-110 transition-transform duration-300 flex-shrink-0",
          style: _normalizeStyle({ backgroundColor: _unref(brandColors).primary + '15' })
        }, [
          (_openBlock(), _createElementBlock("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            class: "h-6 w-6 sm:h-7 sm:w-7",
            style: _normalizeStyle({ color: _unref(brandColors).primary }),
            fill: "none",
            viewBox: "0 0 24 24",
            stroke: "currentColor",
            "stroke-width": "2"
          }, _cache[6] || (_cache[6] = [
            _createElementVNode("path", { d: "M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.7-1.7-1.5-1.9C18.7 10.6 16 10 16 10s-1.3-1.4-2.2-2.3c-.5-.4-1.1-.7-1.8-.7H5c-.6 0-1.1.4-1.4.9l-1.4 2.9A3.7 3.7 0 0 0 2 12v4c0 .6.4 1 1 1h2" }, null, -1),
            _createElementVNode("circle", {
              cx: "7",
              cy: "17",
              r: "2"
            }, null, -1),
            _createElementVNode("path", { d: "M9 17h6" }, null, -1),
            _createElementVNode("circle", {
              cx: "17",
              cy: "17",
              r: "2"
            }, null, -1)
          ]), 4))
        ], 4),
        _createElementVNode("div", {
          class: "px-3 py-1 sm:px-4 sm:py-1.5 rounded-full text-xs sm:text-sm font-bold shadow-sm flex-shrink-0",
          style: _normalizeStyle({
            backgroundColor: _unref(brandColors).primary,
            color: 'white'
          })
        }, _toDisplayString(_ctx.vehicle.vehicle_year), 5)
      ]),
      _createElementVNode("h3", _hoisted_2, [
        _createTextVNode(_toDisplayString(_ctx.vehicle.vehicle_make) + " ", 1),
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.vehicle.vehicle_model), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _cache[7] || (_cache[7] = _createElementVNode("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          class: "h-3.5 w-3.5 sm:h-4 sm:w-4 text-gray-500 dark:text-gray-400 flex-shrink-0",
          fill: "none",
          viewBox: "0 0 24 24",
          stroke: "currentColor",
          "stroke-width": "2"
        }, [
          _createElementVNode("rect", {
            x: "3",
            y: "6",
            width: "18",
            height: "12",
            rx: "2",
            ry: "2"
          }),
          _createElementVNode("path", { d: "M7 10h10M7 14h6" })
        ], -1)),
        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.vehicle.plate_number), 1)
      ])
    ], 4),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", {
          class: "w-9 h-9 sm:w-10 sm:h-10 rounded-full flex items-center justify-center flex-shrink-0",
          style: _normalizeStyle({ backgroundColor: _unref(brandColors).primary + '20' })
        }, [
          (_openBlock(), _createElementBlock("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            class: "h-4 w-4 sm:h-5 sm:w-5",
            style: _normalizeStyle({ color: _unref(brandColors).primary }),
            fill: "none",
            viewBox: "0 0 24 24",
            stroke: "currentColor",
            "stroke-width": "2"
          }, _cache[8] || (_cache[8] = [
            _createElementVNode("circle", {
              cx: "12",
              cy: "12",
              r: "10"
            }, null, -1),
            _createElementVNode("circle", {
              cx: "12",
              cy: "12",
              r: "6"
            }, null, -1),
            _createElementVNode("circle", {
              cx: "12",
              cy: "12",
              r: "2"
            }, null, -1)
          ]), 4))
        ], 4),
        _createElementVNode("div", _hoisted_8, [
          _cache[9] || (_cache[9] = _createElementVNode("p", { class: "text-xs text-gray-500 dark:text-gray-400 font-medium" }, "Registered Tires", -1)),
          _createElementVNode("p", _hoisted_9, [
            _createTextVNode(_toDisplayString(_ctx.vehicle.tires_count || 0) + " ", 1),
            _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.vehicle.tires_count === 1 ? 'tire' : 'tires'), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('view', _ctx.vehicle))),
          class: "flex-1 inline-flex items-center justify-center gap-1.5 2xl:gap-1 px-2.5 2xl:px-2 py-2.5 2xl:py-2 text-sm 2xl:text-xs font-semibold text-white rounded-xl transition-all duration-200 shadow-md hover:shadow-lg active:scale-95",
          style: _normalizeStyle({ backgroundColor: _unref(brandColors).primary })
        }, _cache[10] || (_cache[10] = [
          _createElementVNode("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            class: "h-4 w-4 2xl:h-3.5 2xl:w-3.5 flex-shrink-0",
            fill: "none",
            viewBox: "0 0 24 24",
            stroke: "currentColor",
            "stroke-width": "2"
          }, [
            _createElementVNode("path", { d: "M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z" }),
            _createElementVNode("circle", {
              cx: "12",
              cy: "12",
              r: "3"
            })
          ], -1),
          _createElementVNode("span", { class: "truncate" }, "View", -1)
        ]), 4),
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('edit', _ctx.vehicle))),
          class: "flex-1 inline-flex items-center justify-center gap-1.5 2xl:gap-1 px-2.5 2xl:px-2 py-2.5 2xl:py-2 text-sm 2xl:text-xs font-semibold rounded-xl transition-all duration-200 border-2 hover:shadow-md active:scale-95",
          style: _normalizeStyle({
            color: _unref(brandColors).primary,
            borderColor: _unref(brandColors).primary + '40',
            backgroundColor: 'transparent'
          })
        }, _cache[11] || (_cache[11] = [
          _createElementVNode("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            class: "h-4 w-4 2xl:h-3.5 2xl:w-3.5 flex-shrink-0",
            fill: "none",
            viewBox: "0 0 24 24",
            stroke: "currentColor",
            "stroke-width": "2"
          }, [
            _createElementVNode("path", { d: "M17 3a2.85 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z" }),
            _createElementVNode("path", { d: "m15 5 4 4" })
          ], -1),
          _createElementVNode("span", { class: "truncate" }, "Edit", -1)
        ]), 4),
        _createElementVNode("button", {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('delete', _ctx.vehicle))),
          class: "flex-1 inline-flex items-center justify-center gap-1.5 2xl:gap-1 px-2.5 2xl:px-2 py-2.5 2xl:py-2 text-sm 2xl:text-xs font-semibold text-red-600 dark:text-red-400 rounded-xl transition-all duration-200 border-2 border-red-200 dark:border-red-800 hover:bg-red-50 dark:hover:bg-red-900/20 hover:shadow-md active:scale-95"
        }, _cache[12] || (_cache[12] = [
          _createStaticVNode("<svg xmlns=\"http://www.w3.org/2000/svg\" class=\"h-4 w-4 2xl:h-3.5 2xl:w-3.5 flex-shrink-0\" fill=\"none\" viewBox=\"0 0 24 24\" stroke=\"currentColor\" stroke-width=\"2\"><path d=\"M3 6h18\"></path><path d=\"M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6\"></path><path d=\"M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2\"></path></svg><span class=\"truncate\">Delete</span>", 2)
        ]))
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("button", {
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('view', _ctx.vehicle))),
          class: "w-full inline-flex items-center justify-center gap-2 px-4 py-2.5 text-sm font-semibold text-white rounded-xl transition-all duration-200 shadow-md hover:shadow-lg active:scale-95",
          style: _normalizeStyle({ backgroundColor: _unref(brandColors).primary })
        }, _cache[13] || (_cache[13] = [
          _createElementVNode("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            class: "h-4 w-4 flex-shrink-0",
            fill: "none",
            viewBox: "0 0 24 24",
            stroke: "currentColor",
            "stroke-width": "2"
          }, [
            _createElementVNode("path", { d: "M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z" }),
            _createElementVNode("circle", {
              cx: "12",
              cy: "12",
              r: "3"
            })
          ], -1),
          _createElementVNode("span", null, "View Details", -1)
        ]), 4),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("button", {
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('edit', _ctx.vehicle))),
            class: "flex-1 inline-flex items-center justify-center gap-2 px-3 py-2.5 text-sm font-semibold rounded-xl transition-all duration-200 border-2 hover:shadow-md active:scale-95",
            style: _normalizeStyle({
              color: _unref(brandColors).primary,
              borderColor: _unref(brandColors).primary + '40',
              backgroundColor: 'transparent'
            })
          }, _cache[14] || (_cache[14] = [
            _createElementVNode("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              class: "h-4 w-4 flex-shrink-0",
              fill: "none",
              viewBox: "0 0 24 24",
              stroke: "currentColor",
              "stroke-width": "2"
            }, [
              _createElementVNode("path", { d: "M17 3a2.85 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z" }),
              _createElementVNode("path", { d: "m15 5 4 4" })
            ], -1),
            _createElementVNode("span", null, "Edit", -1)
          ]), 4),
          _createElementVNode("button", {
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('delete', _ctx.vehicle))),
            class: "flex-1 inline-flex items-center justify-center gap-2 px-3 py-2.5 text-sm font-semibold text-red-600 dark:text-red-400 rounded-xl transition-all duration-200 border-2 border-red-200 dark:border-red-800 hover:bg-red-50 dark:hover:bg-red-900/20 hover:shadow-md active:scale-95"
          }, _cache[15] || (_cache[15] = [
            _createElementVNode("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              class: "h-4 w-4 flex-shrink-0",
              fill: "none",
              viewBox: "0 0 24 24",
              stroke: "currentColor",
              "stroke-width": "2"
            }, [
              _createElementVNode("path", { d: "M3 6h18" }),
              _createElementVNode("path", { d: "M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6" }),
              _createElementVNode("path", { d: "M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2" })
            ], -1),
            _createElementVNode("span", null, "Delete", -1)
          ]))
        ])
      ])
    ])
  ], 4))
}
}

})